import { wccModules } from 'enums/wccModules';
import { inject, injectable } from 'inversify';
import { PureComputed, Subscribable, SubscribableOrNullableValue } from 'knockout';
import { IWCCStorageManager } from 'managers/iStorage';
import { TopicManager } from 'managers/topic';
import { TopicThread } from 'models/topicThread';
import './ideationVotesBubbles.html';
import './ideationVotesBubbles.scss';

export interface CommentIdeationVotesBubblesVMConfig {
    comment: SubscribableOrNullableValue<TopicThread>
    inactive: SubscribableOrNullableValue<boolean>
}

@injectable()
export default class CommentIdeationVotesBubblesVM {
    upvotes: Subscribable<number>
    downvotes: Subscribable<number>
    total: Subscribable<number>

    hasDownvotes: Subscribable<boolean>

    constructor(
        @inject(wccModules.componentConfig) config: CommentIdeationVotesBubblesVMConfig,
        @inject(wccModules.componentInfo) info: ko.components.ComponentInfo,
        @inject(wccModules.storage) storage: IWCCStorageManager
    ) {
        const comment = ko.flattenComputed(config.comment);
        const inactiveMode = ko.flattenComputed(config.inactive, false);

        const topicId = comment.pluck(c => c.topicId);

        const topicManager = storage.get(TopicManager, { topicId });
        const topic = topicManager.pluck(m => m.topic);
        const topicDownvotes = topic.pluck(t => t.ideationDownvotes, 0);

        this.upvotes = comment.pluck(c => c.upvotesCount, 0);
        this.downvotes = comment.pluck(c => c.downvotesCount, 0);
        this.total = ko.pureComputed(() => this.upvotes() - this.downvotes());

        this.hasDownvotes = topicDownvotes.is(v => v > 0);

        ko.applyBindingsToNode(info.element, {
            'css': {
                'topic__comment__ideation-votes-bubbles': true,
                'topic__comment__ideation-votes-bubbles--inactive': inactiveMode,
                'topic__comment__ideation-votes-bubbles--with-downvotes': this.hasDownvotes
            }
        }, this);
    }
}